import React from 'react';
import { Spin } from 'antd';
import { withTranslation } from "react-i18next";

class Loading extends React.Component {
    
  render() {
    var { t } = this.props;
    return (
        <div>
          <Spin size="large" tip={t('loading')}></Spin>
        </div>
    );
  }
}

export default withTranslation()(Loading);